import { HttpClient } from './HttpClient.js';

export const DocumentsService = {
    async getCategories() {
        return await HttpClient.get(`/category/get-categories`).then(response => response);
    },
    async createCategoryDocument(form) {
        return await HttpClient.postJSON(`/category/create-category`, form).then(response => response);
    },
    async editCategoryDocument(id, form) {
        return await HttpClient.postJSON(`/category/edit-category/${id}`, form).then(response => response);
    },
    async deleteCategoryDocument(id) {
        return await HttpClient.delete(`/category/delete-category/${id}`).then(response => response);
    },
    
    
    async getSubcategories() {
        return await HttpClient.get(`/subcategory/get-subcategories`).then(response => response);
    },
    async getSubcategoriesByCategory(id) {
        return await HttpClient.get(`/subcategory/get-subcategories-by-category/${id}`).then(response => response);
    },
    async createSubcategoryDocument(form) {
        return await HttpClient.postJSON(`/subcategory/create-subcategory`, form).then(response => response);
    },
    async editSubcategoryDocument(id, form) {
        return await HttpClient.postJSON(`/subcategory/edit-subcategory/${id}`, form).then(response => response);
    },
    async deleteSubcategoryDocument(id) {
        return await HttpClient.delete(`/subcategory/delete-subcategory/${id}`).then(response => response);
    },

    
    async getDocuments() {
        return await HttpClient.get(`/document/get-documents`).then(response => response);
    },
    async getDocumentURL(id, idUsuario) {
        return await HttpClient.get(`/document/get-document-url/${id}/${idUsuario}`).then(response => response);
    },
    async createDocument(form) {
        return await HttpClient.post(`/document/create-document`, form).then(response => response);
    },
    async deleteDocument(id) {
        return await HttpClient.delete(`/document/delete-document/${id}`).then(response => response);
    },
    async getProgressByUser(id) {
        return await HttpClient.get(`/document/get-progress-by-user/${id}`).then(response => response);
    },
}